/* global dataLayer */
export default function gtmEvent(data) {
  if (typeof dataLayer !== 'undefined') {
    dataLayer.push(data)
  }
}
